import { useEffect } from "react";

export function useRefetchOnWindowActive(refetch: () => void) {
  useEffect(() => {
    const reload = () => refetch();

    window.addEventListener("focus", reload);

    return () => window.removeEventListener("focus", reload);
  }, [refetch]);
}
